import { BaseSearchDTO } from "./baseSearchDTO.interface";

export interface SearchCallRecordsDTO extends BaseSearchDTO {
  filters?: {
    contactId?: string;
    callDate?: Date;
  }
}
